import { IBrandData } from '../models/IBrandData';
import { Actions, ActionTypes } from './brands.actions';

export interface IBrandState {
  brands: Map<string, IBrandData>;
}

const InitBrandsState: IBrandState = {
    brands: new Map(),
  }
;

export function brandsReducer(state: IBrandState = InitBrandsState, action: Actions): IBrandState {
  switch (action.type) {
    case ActionTypes.SET_BRANDS:
        const brands = new Map<string, IBrandData>();    
        for (const brandData of action.payload) {
            brands.set(brandData.id, {...brandData});
        }
        return {brands};
    default:
      return state;
  }
}
